{
  "version": 1,
  "asset_id": "272fac35-0869-4107-b001-152c813aac12",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/272fac35-0869-4107-b001-152c813aac12/rv_kitchens_rv_bathrooms.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/272fac35-0869-4107-b001-152c813aac12/rv_kitchens_rv_bathrooms.webp",
  "original_filename": "rv_kitchens_rv_bathrooms.webp",
  "size": 34328,
  "content_type": "image/webp",
  "created_at": "2026-07-14T02:53:30Z"
}
